const MAX_TIME_BETWEEN_SCROLL_EVENTS = 100;

export function moveTo(element, targetPosition) {
    return new Promise((resolve) => {
        let timer = null;

        const handleScroll = (ev) => {
            clearTimeout(timer)

            if (ev.target.scrollTop === targetPosition) {
                element.removeEventListener('scroll', handleScroll)
                resolve()
            } else {
                timer = setTimeout(() => {
                    element.removeEventListener('scroll', handleScroll)
                    resolve()
                }, MAX_TIME_BETWEEN_SCROLL_EVENTS)
            }
        }

        const normalizedScrollTop = Math.round(element.scrollTop) // fix decimal values, ex: 123.5
        const isBottom = normalizedScrollTop + element.clientHeight === element.scrollHeight;

        if (isBottom || element.scrollTop === targetPosition) {
            resolve()
        } else {
            element.addEventListener('scroll', handleScroll)
            element.scrollTop = targetPosition
        }
    })
}
